import { render, staticRenderFns } from "./SyncLogsList.vue?vue&type=template&id=1176fe33&"
import script from "./SyncLogsList.vue?vue&type=script&lang=js&"
export * from "./SyncLogsList.vue?vue&type=script&lang=js&"
import style0 from "./SyncLogsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports